import { useContext } from 'react';
import { IdentityContext } from '../identity/state/IdentityContext';
import type { TaxPaymentScope } from './dashboardTypes';

/** The platform permission (`platform.taxpayments.read`, Super Admin only). It is not in the access token; `GET /api/me` lists it for display. */
export const PLATFORM_TAX_PAYMENTS_READ = 'platform.taxpayments.read';

/**
 * Which door the dashboard reads through. Only a signed-in user whose ACTIVE role is known to hold the platform permission is sent to the platform door; an
 * unknown list (older server, mock identity, still loading) means the company door, so a company user can never be sent to cross-company data on a guess. This is
 * display routing only: the server decides, and a company user who asks for another company is refused (403, audited).
 */
export function useTaxPaymentScope(): TaxPaymentScope {
  const granted = useContext(IdentityContext)?.me?.activePermissions;
  return granted?.includes(PLATFORM_TAX_PAYMENTS_READ) ? 'platform' : 'company';
}
